<template>
  <div :style="style" ref="lavContainer"></div>
</template>

<script>
export default {
  props: {
    options: {
      // type: Object,
      required: true
    },
    height: Number | String,
    width: Number | String
  },
  computed: {
    style() {
      return {
        width: this.width || '100%',
        height: this.height || '100%',
        margin: '0 auto'
      }
    }
  },
  mounted() {
    this.anim = window.bodymovin.loadAnimation({
      container: this.$refs.lavContainer,
      renderer: 'svg',
      loop: this.options.loop,
      autoplay: this.options.autoplay !== false,
      animationData: this.options.animationData,
      rendererSettings: this.options.rendererSettings
    })
    this.$emit('animCreated', this.anim)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/lottie/index.vue